<script context="module" lang="ts">
	import Location from '$lib/components/locations/Location.svelte';
	import MetaTags from '$lib/components/utils/MetaTags.svelte';
	import Wrapper from '$lib/components/utils/ResponsiveWrapper.svelte';

	import graphicA from '$lib/img/general/active-graphic-skills-2.jpg';
</script>

<MetaTags
	title="About Active"
	desc="Two locations located in the heart of O'Connor and Jandakot, Active has a place for you."
/>

<Wrapper title="About & Locations">
	<div class="pt-8" />
	<div class="grid grid-cols-1 gap-x-8 lg:grid-cols-2">
		<div>
			<article class="rounded-md bg-white p-4 dark:bg-zinc-800 md:bg-transparent">
				<h3 class="text-3xl text-lg">Contact Details</h3>
				<p>
					Our main phone is <a href="tel:0417503517" class="text-red-600">0417503517</a>, please see
					below for our location-specific extensions. Alternatively, if you prefer email, our
					address is
					<a href="mailto:info@activegym.com.au" class="text-red-600">info@activegym.com.au</a>.
					Please be mindful that during peak hours, there can be many people trying to get through,
					and there could be a delay in getting back to you.
				</p>

				<br />
				<p>
					You can also message us via our <a
						href="https://www.instagram.com/activegymnastics/"
						class="text-red-600">Instagram</a
					>
					and <a href="https://www.facebook.com/ActiveGymnastics/" class="text-red-600">Facebook</a>
					messenger, however, please note these may not be checked as frequently as our email & voicemails.
					To find the latest updates and information, important notices will be sent to your registered
					email. Other notices will be posted across this website, the parent portal and social media.
				</p>
			</article>
			<article class="mt-2 rounded-md bg-white p-4 dark:bg-zinc-800 md:bg-transparent">
				<h3 class="text-3xl">Our Locations</h3>
				<p>
					All of our locations feature Active's leading curriculum, innovative systems and
					superb staff. Whether you are doing it for fun, or dreaming of being a world-class
					athlete we've got you covered. We encourage you to <a href="/dash" class="text-red-600"
						>check our portal</a
					> for the latest class times & programs, as it can vary at each location.
				</p>
			</article>
		</div>
		<img
			src={graphicA}
			alt="Coach spotting a gymnast balancing one leg in the air in front of them."
			class="m-auto hidden h-[32rem] lg:block"
		/>
	</div>
	<div>
		<div class="mt-2 grid grid-cols-1 gap-4 md:grid-cols-2">
			<Location
				locationName="O'Connor"
				locationAddr="u10 & 11 / 352 South St"
				locationHours="Mon - Sat"
				locationDesc="Located minutes away from major SOR schools, our O'Connor location is outfitted with FIG-grade equipment. With three foam pits, two sprung floors & so much more - we've got something for everyone."
				locationPhone="0417503517; ext 1"
				locationImage="https://imagedelivery.net/lrWT10jUZFy-ZAYFAQqPzA/fd3e5871-9495-492d-dde4-0934ea8a3c00/w=1024,h=512,fit=cover"
				locationImageFocal="center 100%"
			/>
			<Location
				locationName="Jandakot"
				locationAddr="u3 / 30 Biscayne Way"
				locationHours="Mon - Sat"
				locationDesc="Just behind Bunnings Cockburn, and minutes away from Cockburn Gateway - our Jandakot location is in the middle of it all. Jandakot features a climbing wall over Active's signature red foam pit, a sprung floor and a huge 900sqm space full of equipment."
				locationPhone="0417503517; ext 2"
				locationImage="https://imagedelivery.net/lrWT10jUZFy-ZAYFAQqPzA/5daf3884-f8f9-40c4-69d4-51d6d48a6100/w=1024,h=512,fit=cover"
				locationImageFocal="center center"
			/>
		</div>
	</div>
</Wrapper>
